import { render, staticRenderFns } from "./educationDivision4.vue?vue&type=template&id=30540775"
import script from "./educationDivision4.vue?vue&type=script&lang=js"
export * from "./educationDivision4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30540775')) {
      api.createRecord('30540775', component.options)
    } else {
      api.reload('30540775', component.options)
    }
    module.hot.accept("./educationDivision4.vue?vue&type=template&id=30540775", function () {
      api.rerender('30540775', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/div/educationDivision4.vue"
export default component.exports